// GSAP base + react - leave this alone
export * from "gsap";
export * from "@gsap/react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";

// Export * from each plugin we're using here
export * from "gsap/ScrollTrigger";
export * from "gsap/SplitText";

// Import from each plugin we're using here
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

// Register them all
gsap.registerPlugin(
  useGSAP, 
  ScrollTrigger,
  SplitText,
);
